import { COMMUNITY_NAME_MAX_LENGTH, COMMUNITY_DEFAULT_LOGO_URL } from "Config";

export const getCommunityDisplayName = community => {
  return (
    community.abbreviation ||
    (community.name.length <= COMMUNITY_NAME_MAX_LENGTH
      ? community.name
      : community.name.substring(0, COMMUNITY_NAME_MAX_LENGTH) + " ...")
  );
};

export const getCommunityRoute = community => {
  return `/community/${community.url}/${community.id}`;
};

export const getCommunityLogoUrl = community => {
  return community && community.avatarUrl
    ? community.avatarUrl
    : COMMUNITY_DEFAULT_LOGO_URL;
};

export const getFinancialsRoute = () => {
  return `/financials`;
};

export const isClientAccess = (community, portail) => {
  return (community && community.owner) || portail === "CLIENT";
};

export const isFiduciaryAccess = community => {
  return community && !community.owner;
};

export const getDataAppStatus = (community, portail) => {
  if (isFiduciaryAccess(community)) {
    return community.dataActivated;
  } else if (isClientAccess(community, portail)) {
    return community.owner.dataActivated;
  }
};
export const isManagerAccess = loggedAs => {
  return loggedAs === "MANAGER";
};

export const isCollaboratorAccess = loggedAs => {
  return loggedAs === "COLLABORATOR";
};

export const isSupervisorAccess = loggedAs => {
  return loggedAs === "SUPERVISOR";
};

export const getUrlProperties = () => {
  return new Map(
    window.location.search
      .slice(1)
      .split("&")
      .map(kv => kv.split("="))
  );
};



// WEBPACK FOOTER //
// ./src/utils/community.js